import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  scanQrFailure,
  scanQrRequest,
  scanQrSuccess,
  validateMobileFailure,
  validateMobileRequest,
  validateMobileSuccess,
  claimRewardRequest,
  claimRewardSuccess,
  claimRewardFailure,
  claimStatusFetchRequest,
  claimStatusFetchSuccess,
  claimStatusFetchFailure,
} from '../../slices/scanCampaignSlice';
import { BASEURL } from '../../../BaseUrl/BaseUrl';

function validateQrByCode(qrCode) {
  return axios.get(`${BASEURL}/qrs/scan/${qrCode}`);
}

export function* handleScanQr(action) {
  try {
    const { qrCode } = action.payload || {};
    if (!qrCode) {
      yield put(scanQrFailure('Missing QR code'));
      return;
    }

    yield put(scanQrRequest());

    const response = yield call(validateQrByCode, qrCode);

    const qr = response?.data?.data?.qr?.[0] ?? response?.data?.data?.qr ?? response?.data?.data ?? response?.data;

    yield put(scanQrSuccess(qr));
  } catch (error) {
    yield put(
      scanQrFailure(
        error?.response?.data?.meta?.message ||
          error?.response?.data?.error?.message ||
          error?.message ||
          'Failed to validate QR code'
      )
    );
  }
}

export function* handleValidateMobile(action) {
  try {
    const { contactNo, companyId, qrCode } = action.payload || {};

    if (!contactNo || !companyId || !qrCode) {
      yield put(validateMobileFailure('Missing required fields'));
      return;
    }

    yield put(validateMobileRequest());

    const response = yield call(() =>
      axios.post(`${BASEURL}/farmers/check-mobile`, {
        contact_no: contactNo,
        companyId,
        qr_code: qrCode,
      })
    );

    yield put(validateMobileSuccess(response.data));
  } catch (error) {
    yield put(
      validateMobileFailure(
        error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          'Failed to validate mobile number'
      )
    );
  }
}

export function* handleClaimReward(action) {
  try {
    const {
      qrCode,
      firstName,
      lastName,
      contactNo,
      state,
      district,
      birthDate,
      upiId,
      companyId,
      designationId,
      // eslint-disable-next-line camelcase
      campaign_id,
      // eslint-disable-next-line camelcase
      product_id,
      amount,
      village,
      pincode,
      dealer,
      taluka,
    } = action.payload || {};

    if (
      !qrCode ||
      !firstName ||
      !lastName ||
      !contactNo ||
      !state ||
      !district ||
      !upiId ||
      !companyId ||
      !designationId ||
      // eslint-disable-next-line camelcase
      !campaign_id ||
      // eslint-disable-next-line camelcase
      !product_id ||
      !amount
    ) {
      yield put(claimRewardFailure('Missing required fields'));
      return;
    }

    yield put(claimRewardRequest());

    const response = yield call(() =>
      axios.post(`${BASEURL}/farmers/claims`, {
        qr_code: qrCode,
        first_name: firstName,
        last_name: lastName,
        contact_no: contactNo,
        state,
        district,
        ...(birthDate ? { birth_date: birthDate } : {}),
        upi_id: upiId,
        companyId,
        designationId,
        campaign_id,
        product_id,
        amount,
        ...(village ? { village } : {}),
        ...(pincode ? { pincode } : {}),
        ...(dealer ? { dealer } : {}),
        ...(taluka ? { taluka } : {}),
      })
    );

    yield put(claimRewardSuccess(response.data));
  } catch (error) {
    yield put(
      claimRewardFailure(
        error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          'Failed to submit claim'
      )
    );
  }
}

export function* handleFetchClaimStatus(action) {
  const { mobileNumber, claimId } = action.payload || {};
  const mobile = mobileNumber != null ? String(mobileNumber).trim() : '';
  const cid = claimId != null ? String(claimId).trim() : '';

  if (!mobile || !cid) {
    yield put(claimStatusFetchFailure('Missing mobile number or claim id'));
    return;
  }

  try {
    yield put(claimStatusFetchRequest());
    const response = yield call(() =>
      axios.get(`${BASEURL}/claims/my-claims/${encodeURIComponent(mobile)}/${encodeURIComponent(cid)}`)
    );
    yield put(
      claimStatusFetchSuccess({
        meta: response?.data?.meta ?? null,
        data: response?.data?.data ?? null,
      })
    );
  } catch (error) {
    yield put(
      claimStatusFetchFailure(
        error?.response?.data?.error?.message ||
          error?.response?.data?.meta?.message ||
          error?.message ||
          'Failed to load claim status'
      )
    );
  }
}
